import { render, staticRenderFns } from "./liveSet.vue?vue&type=template&id=3fbb7f0b&scoped=true&"
import script from "./liveSet.vue?vue&type=script&lang=js&"
export * from "./liveSet.vue?vue&type=script&lang=js&"
import style0 from "./liveSet.vue?vue&type=style&index=0&id=3fbb7f0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbb7f0b",
  null
  
)

export default component.exports